import { InvalidDeviceRegistrationRedirectError } from '../../../errors/InvalidDeviceRegistrationRedirectError';

type GetDeviceRegistrationTokenFromUrlParams = {
  url: string;
};

/**
 * Safely extracts the device token from a device registration redirect URL.
 *
 * This function validates that the URL is a valid device registration redirect
 * then extracts and returns the deviceToken.
 *
 * @returns The device token as a string if valid.
 * @throws InvalidDeviceRegistrationRedirectError If the URL is not a valid device registration redirect.
 */
export const getDeviceRegistrationTokenFromUrl = ({
  url,
}: GetDeviceRegistrationTokenFromUrlParams): string => {
  let urlObject: URL;

  try {
    urlObject = new URL(url);
  } catch {
    throw new InvalidDeviceRegistrationRedirectError();
  }

  const deviceRegistrationToken = urlObject.searchParams.get(
    'deviceRegistrationToken'
  );

  if (!deviceRegistrationToken || deviceRegistrationToken.trim() === '') {
    throw new InvalidDeviceRegistrationRedirectError();
  }

  return deviceRegistrationToken;
};
